import React from 'react'
// Packages
import moment from 'moment'
// Modules
import PreviewBlock from './modules/PreviewBlock'
// Components
import Seprator from 'components/Separator'
import MediaGallery from 'components/MediaGallery'
import Icons from 'components/Icons'
// Assets
import NoUser from 'assets/images/no_user.jpg'
import './feedPost.scss'
import { checkImageUrl } from 'utils/modules/Handlers'

const FeedPost = ({ data }) => {
    const getHours = (startDate) => {
        const endDate = moment();
        const duration = moment.duration(endDate.diff(startDate));
        const hours = duration.asHours();
        return hours
    }

    return (
        <div className={`waggle-post-listing-detail ${getHours(data.date_created) < 1 && 'new' }`}>
            <div className="waggle-post-content">
                <div className="content-header">
                    <img className="waggle-post-user" src={checkImageUrl(data.user.profile_photo, NoUser)} alt="" />
                    <Seprator width={20} />
                    <div className="content-header--user-info">
                        <div className="upper-info">
                            <div style={{ flex: 2 }}>
                                <p className="user-name">{data.user?.first_name} {data.user?.last_name}</p>
                                {
                                    data.user.user_type === 'buyer' 
                                    ? <Icons.BuyerBadge height={16} className="user-badge" />
                                    : data.user.user_type === 'mortgage_broker'
                                        ? <Icons.BrokerBadge height={16} width={16} className="user-badge" />
                                        : <Icons.ListingAgentBadge height={16} width={16} className="user-badge" />
                                }
                                <span className="dot">•</span>
                                <span className="time">{moment(data.date_created).fromNow()}</span>
                            </div>
                            <div className="save-listing">
                                <img src="../images/icons/save-post.svg" alt="" />
                            </div>
                        </div>
                        <span className="user-tag">{data.user?.email}</span>
                    </div>
                </div>
                <Seprator height={30} />
                <div className="content-text">
                    <h4 className="content-text--title">{data.title}</h4>
                    <Seprator height={15} />
                    <p className="content-text--body">
                        {data.body}
                    </p>
                </div>
                <Seprator height={20} />
                {
                    data?.matterport &&
                    <PreviewBlock data={data.matterport} />
                }
                <Seprator height={20} />
                {
                    data.files.length > 0 &&
                    <React.Fragment>
                        <MediaGallery data={data.files} waggle />
                        <Seprator height={30} />
                    </React.Fragment>
                }
            </div>
        </div>
    )
}

export default FeedPost;